module.exports = __webpack_public_path__ + "img/aboutUs.37e3b74.jpg";